module.exports = __webpack_public_path__ + "static/polygon_left-cd8f7d0404b52a8732b8f0b9ada31cdd.png";